import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { MEETING_TYPES } from 'MeetingsBase/constants/enums';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const getMeetingTypeOptions = () => {
  return [{
    text: I18n.text('filters.meetingType.all'),
    value: null
  }, ...Object.keys(MEETING_TYPES).map(type => ({
    value: type,
    text: I18n.text(`filters.meetingType.${MEETING_TYPES[type]}`)
  }))];
};
const MeetingTypeSelect = ({
  value,
  onChange,
  disabled
}) => {
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.meetingType.meetingTypeLabel"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      "data-selenium-test": "meeting-type-select",
      disabled: disabled,
      buttonUse: "link",
      value: value,
      onChange: e => onChange(e.target.value)
      // @ts-expect-error No overload matches this call.
      ,
      options: getMeetingTypeOptions(),
      placeholder: I18n.text('filters.meetingType.all'),
      menuWidth: "auto"
    })
  });
};
export default MeetingTypeSelect;